"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendableEthersLiquity = void 0;
const sendTransaction = (tx) => tx.send();
/**
 * Ethers-based implementation of {@link @liquity/lib-base#SendableLiquity}.
 *
 * @public
 */
class SendableEthersLiquity {
    constructor(populatable) {
        this._populate = populatable;
    }
    async approveToken(tokenAddress, toAddress, amount, overrides) {
        return this._populate.approveERC20(tokenAddress, toAddress, amount, overrides).then(sendTransaction);
    }
    async multipleApproveERC20(tokenAddress, toAddress, amount) {
        return this._populate.multipleApproveERC20(tokenAddress, toAddress, amount);
    }
    async mintToken(tokenAddress, overrides) {
        return this._populate.mintERC20(tokenAddress, overrides).then(sendTransaction);
    }
    async mintYUSD(overrides) {
        return this._populate.mintYUSD(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.openTrove} */
    async openTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .openTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.openTroveLeverUp} */
    async openTroveLeverUp(params, ICRWithFees, troveOpen, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .openTroveLeverUp(params, ICRWithFees, troveOpen, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.closeTrove} */
    closeTrove(overrides) {
        return this._populate.closeTrove(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.closeTroveUnleverUp} */
    closeTroveUnleverUp(params, overrides) {
        return this._populate.closeTroveUnleverUp(params, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.adjustTrove} */
    adjustTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .adjustTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.addCollLeverUp} */
    addCollLeverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .addCollLeverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.addCollLeverUp} */
    withdrawCollUnleverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .withdrawCollUnleverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.depositCollateral} */
    depositCollateral(collaterals, ICRWithFees, overrides) {
        return this._populate.depositCollateral(collaterals, ICRWithFees, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.withdrawCollateral} */
    withdrawCollateral(collaterals, ICRWithFees, overrides) {
        return this._populate.withdrawCollateral(collaterals, ICRWithFees, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.borrowYUSD} */
    borrowYUSD(amount, ICRWithFees, maxBorrowingRate, overrides) {
        return this._populate.borrowYUSD(amount, ICRWithFees, maxBorrowingRate, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.repayYUSD} */
    repayYUSD(amount, ICRWithFees, overrides) {
        return this._populate.repayYUSD(amount, ICRWithFees, overrides).then(sendTransaction);
    }
    /** @internal */
    setPrice(price, overrides) {
        return this._populate.setPrice(price, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.liquidate} */
    liquidate(address, liquidator, overrides) {
        return this._populate.liquidate(address, liquidator, overrides).then(sendTransaction);
    }
    // /** {@inheritDoc @liquity/lib-base#SendableLiquity.liquidateUpTo} */
    // liquidateUpTo(
    //   maximumNumberOfTrovesToLiquidate: number,
    //   overrides?: EthersTransactionOverrides
    // ): Promise<SentEthersLiquityTransaction<LiquidationDetails>> {
    //   return this._populate
    //     .liquidateUpTo(maximumNumberOfTrovesToLiquidate, overrides)
    //     .then(sendTransaction);
    // }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.depositYUSDInStabilityPool} */
    depositYUSDInStabilityPool(amount, overrides) {
        return this._populate
            .depositYUSDInStabilityPool(amount, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.withdrawYUSDFromStabilityPool} */
    withdrawYUSDFromStabilityPool(amount, overrides) {
        return this._populate.withdrawYUSDFromStabilityPool(amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.withdrawGainsFromStabilityPool} */
    withdrawGainsFromStabilityPool(overrides) {
        return this._populate.withdrawGainsFromStabilityPool(overrides).then(sendTransaction);
    }
    claimRewardsSwap(amount, overrides) {
        return this._populate.claimRewardsSwap(amount, overrides).then(sendTransaction);
    }
    stakeLPTokens(amount, overrides) {
        return this._populate.stakeLPTokens(amount, overrides).then(sendTransaction);
    }
    withdrawLPTokens(amount, overrides) {
        return this._populate.withdrawLPTokens(amount, overrides).then(sendTransaction);
    }
    getFarmRewards(overrides) {
        return this._populate.getFarmRewards(overrides).then(sendTransaction);
    }
    stakeYETITokens(amount, overrides) {
        return this._populate.stakeYETITokens(amount, overrides).then(sendTransaction);
    }
    withdrawYETITokens(amount, overrides) {
        return this._populate.withdrawYETITokens(amount, overrides).then(sendTransaction);
    }
    getFarmYETIRewards(overrides) {
        return this._populate.getFarmYETIRewards(overrides).then(sendTransaction);
    }
    async updateVEYETI(yetiAmount, isIncrease, overrides) {
        return this._populate.updateVEYETI(yetiAmount, isIncrease, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.transferCollateralGainToTrove} */
    transferCollateralGainToTrove(overrides) {
        return this._populate.transferCollateralGainToTrove(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.sendYUSD} */
    sendYUSD(toAddress, amount, overrides) {
        return this._populate.sendYUSD(toAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.sendYETI} */
    sendYETI(toAddress, amount, overrides) {
        return this._populate.sendYETI(toAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.redeemYUSD} */
    redeemYUSD(amount, maxRedemptionRate, overrides) {
        return this._populate.redeemYUSD(amount, maxRedemptionRate, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.claimCollateralSurplus} */
    claimCollateralSurplus(overrides) {
        return this._populate.claimCollateralSurplus(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.stakeYETI} */
    stakeYETI(amount, overrides) {
        return this._populate.stakeYETI(amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.unstakeYETI} */
    unstakeYETI(amount, address, overrides) {
        return this._populate.unstakeYETI(amount, address, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.rebase} */
    rebase(overrides) {
        return this._populate.rebase(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.withdrawGainsFromStaking} */
    withdrawGainsFromStaking(address, overrides) {
        return this._populate.withdrawGainsFromStaking(address, overrides).then(sendTransaction);
    }
    // /** {@inheritDoc @liquity/lib-base#SendableLiquity.registerFrontend} */
    // registerFrontend(
    //   kickbackRate: Decimalish,
    //   overrides?: EthersTransactionOverrides
    // ): Promise<SentEthersLiquityTransaction<void>> {
    //   return this._populate.registerFrontend(kickbackRate, overrides).then(sendTransaction);
    // }
    /** @internal */
    _mintUniToken(amount, address, overrides) {
        return this._populate._mintUniToken(amount, address, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.approveUniTokens} */
    approveUniTokens(allowance, overrides) {
        return this._populate.approveUniTokens(allowance, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.pngApproveUniTokens} */
    pngApproveUniTokens(allowance, overrides) {
        return this._populate.pngApproveUniTokens(allowance, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.tjApproveUniTokens} */
    tjApproveUniTokens(allowance, overrides) {
        return this._populate.tjApproveUniTokens(allowance, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.stakeUniTokens} */
    stakeUniTokens(amount, overrides) {
        return this._populate.stakeUniTokens(amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.pngStakeUniTokens} */
    pngStakeUniTokens(amount, overrides) {
        return this._populate.pngStakeUniTokens(amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.tjStakeUniTokens} */
    tjStakeUniTokens(amount, overrides) {
        return this._populate.tjStakeUniTokens(amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.unstakeUniTokens} */
    unstakeUniTokens(amount, overrides) {
        return this._populate.unstakeUniTokens(amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.pngUnstakeUniTokens} */
    pngUnstakeUniTokens(amount, overrides) {
        return this._populate.pngUnstakeUniTokens(amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.tjUnstakeUniTokens} */
    tjUnstakeUniTokens(amount, overrides) {
        return this._populate.tjUnstakeUniTokens(amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.withdrawYETIRewardFromLiquidityMining} */
    withdrawYETIRewardFromLiquidityMining(overrides) {
        return this._populate.withdrawYETIRewardFromLiquidityMining(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.pngWithdrawYETIRewardFromLiquidityMining} */
    pngWithdrawYETIRewardFromLiquidityMining(overrides) {
        return this._populate.pngWithdrawYETIRewardFromLiquidityMining(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.tjWithdrawYETIRewardFromLiquidityMining} */
    tjWithdrawYETIRewardFromLiquidityMining(overrides) {
        return this._populate.tjWithdrawYETIRewardFromLiquidityMining(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.exitLiquidityMining} */
    exitLiquidityMining(overrides) {
        return this._populate.exitLiquidityMining(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.pngExitLiquidityMining} */
    pngExitLiquidityMining(overrides) {
        return this._populate.pngExitLiquidityMining(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.tjExitLiquidityMining} */
    tjExitLiquidityMining(overrides) {
        return this._populate.tjExitLiquidityMining(overrides).then(sendTransaction);
    }
}
exports.SendableEthersLiquity = SendableEthersLiquity;
//# sourceMappingURL=SendableEthersLiquity.js.map